import {
  Component,
  Inject,
  forwardRef,
  NgModule,
  ViewEncapsulation
} from '@angular/core';

import { OSideMenuModule, OSideMenuComponent } from './o-side-menu.component';
import { OSharedModule } from '../../shared';
import { CommonModule } from '@angular/common';

export const DEFAULT_INPUTS_O_SIDE_MENU_GROUP = [
  // title [string]: menu group title. Default: no value.
  'title',

  // icon [string]: material icon. Default: no value.
  'icon'
];


export class OSideMenuGroupComponent {

  public static DEFAULT_INPUTS_O_SIDE_MENU_GROUP = DEFAULT_INPUTS_O_SIDE_MENU_GROUP;

  protected menu: OSideMenuComponent;

  protected title: string;

  constructor(  menu: OSideMenuComponent) {
    this.menu = menu;
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'o-side-menu-group',
  template: `
    <ng-content></ng-content>
  `,
  styles: [`

  `],
  inputs: [
    ...DEFAULT_INPUTS_O_SIDE_MENU_GROUP
  ],
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: OSideMenuComponent, decorators: [{ type: Inject, args: [forwardRef(() => OSideMenuComponent), ] }, ]},
];
}


export class OSideMenuGroupModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [OSideMenuGroupComponent],
  imports: [OSharedModule, CommonModule,OSideMenuModule],
  exports: [OSideMenuGroupComponent],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
